export const EMPTY_LEAD_PROFILE = {
  id: null,
  name: "Основной поиск",
  status: "draft",
  version: 0,
  plan: "free",
  maxServiceTerms: 1,
  rules: {
    serviceTerms: [],
    stopWords: [],
    geographies: [],
    sourceCodes: [],
    minBudget: null,
    budgetCurrency: "RUB",
    allowUnknownBudget: true,
    requireGeography: false,
  },
};

export function editableLeadProfile(profile) {
  return {
    ...EMPTY_LEAD_PROFILE,
    ...(profile || {}),
    rules: {
      ...EMPTY_LEAD_PROFILE.rules,
      ...(profile?.rules || {}),
    },
  };
}

export function splitTerms(value, limit = 20) {
  const seen = new Set();
  return value
    .split(/[,;\n]/)
    .map((item) => item.trim().replace(/\s+/g, " "))
    .filter((item) => {
      const key = item.toLocaleLowerCase("ru-RU").replaceAll("ё", "е");
      if (!item || seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .slice(0, limit);
}

export function leadProfilePayload(
  profile,
  fields,
  status = profile.status,
  aliases = null,
  preserveServiceText = false,
) {
  const minBudget = Number.parseInt(fields.minBudget.replaceAll(/\s/g, ""), 10);
  const serviceText = fields.serviceTerms.trim().replace(/\s+/g, " ");
  return {
    name: profile.name || "Основной поиск",
    status,
    rules: {
      serviceTerms: preserveServiceText
        ? (serviceText ? [serviceText] : [])
        : splitTerms(fields.serviceTerms, profile.maxServiceTerms),
      // Синонимы ниши, понятые ИИ и оставленные человеком. Это не новые ниши,
      // а способы написать ту же услугу, поэтому лимит тарифа их не касается.
      serviceAliases: aliases ?? profile.rules.serviceAliases ?? [],
      stopWords: splitTerms(fields.stopWords, 20),
      geographies: splitTerms(fields.geographies, 10),
      sourceCodes: profile.rules.sourceCodes,
      minBudget: Number.isFinite(minBudget) && minBudget > 0 ? minBudget : null,
      budgetCurrency: profile.rules.budgetCurrency,
      allowUnknownBudget: profile.rules.allowUnknownBudget,
      requireGeography: profile.rules.requireGeography,
    },
  };
}

export function textFields(profile) {
  return {
    serviceTerms: profile.rules.serviceTerms.join(", "),
    stopWords: profile.rules.stopWords.join(", "),
    geographies: profile.rules.geographies.join(", "),
    minBudget: profile.rules.minBudget ? String(profile.rules.minBudget) : "",
  };
}
